import { render } from "./videomuiPlayer.vue?vue&type=template&id=66346d37"
import script from "./videomuiPlayer.vue?vue&type=script&lang=js"
export * from "./videomuiPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__